import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import { AccountMixTradeLineComponent } from 'components/FactorTradelineComponent/AccountMixFactorTradeline/AccountMixTradelineComponent';

const AccountMixAutoLoansTradelinesModuleView = props => {
  const {
    tradelines,
    userInfo,
    selectedBureau,
    profileContainer,
    creditReports,
  } = props;
  const totalBalance = tradelines?.reduce(
    (acumulator, tradeline) => acumulator + tradeline?.currentBalance,
    0,
  );
  if (tradelines?.length > 0) {
    return (
      <FlexContainer className={'flex-column'}>
        <FlexContainer className={'bgNeutral025 margt20 justify-between'}>
          <Label type="Body-2" className={'bold margtb8 margl10 text-12'}>
            AUTO LOANS
          </Label>
          <Label type="Body-2" className={'margtb8 margr10 text-12'}>
            ${totalBalance?.toLocaleString()}
          </Label>
        </FlexContainer>
        <FlexContainer className={'flex-column marglr48 m-marglr16'}>
          {tradelines?.map((tradeline, index) => (
            <AccountMixTradeLineComponent
              key={'account-mix-auto-loans-tradeline-' + index}
              tradeline={tradeline}
              selectedBureau={selectedBureau}
              userInfo={userInfo}
              profileContainer={profileContainer}
              creditReports={creditReports}
              isSuccess
            />
          ))}
        </FlexContainer>
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};

export default AccountMixAutoLoansTradelinesModuleView;
